import { Category, MealCategory } from '../types';

export const CATEGORIES: Category[] = [
  { name: 'Fruits', emoji: '🍓' },
  { name: 'Légumes', emoji: '🥦' },
  { name: 'Produits laitiers', emoji: '🧀' },
  { name: 'Viande', emoji: '🥩' },
  { name: 'Boulangerie', emoji: '🍞' },
  { name: 'Épicerie', emoji: '🥫' },
  { name: 'Boissons', emoji: '💧' },
  { name: 'Entretien', emoji: '🧻' },
  { name: 'Autre', emoji: '🛒' }
];

export const MEAL_CATEGORIES: MealCategory[] = [
  { name: 'Repas rapide', emoji: '🍳', color: '#e0f7fa' },
  { name: 'Dîner familial', emoji: '🍲', color: '#fff9c4' },
  { name: 'Occasion spéciale', emoji: '🎉', color: '#f8bbd0' },
  { name: 'Restes', emoji: '🥡', color: '#dcedc8' },
  { name: 'Restaurant', emoji: '🍕', color: '#ffccbc' }
];

export const DEFAULT_GROCERY_ITEMS = [
  { id: 1, name: "Milk", emoji: "🧀", type: "Dairy", quantity: 1, important: true, bought: false },
  { id: 2, name: "Bread", emoji: "🍞", type: "Bakery", quantity: 1, important: false, bought: true }
];

export const API_ENDPOINTS = {
  GROCERIES: '/groceries',
  MEALS: '/meals',
  STATS: '/groceries/stats'
};

export const CSS_VARIABLES = {
  '--background-color': '#f4f4f9',
  '--container-bg': '#ffffff',
  '--primary-text': '#333',
  '--secondary-text': '#777',
  '--accent-color': '#007bff',
  '--accent-hover': '#0056b3',
  '--border-color': '#e0e0e0',
  '--shadow': '0 4px 12px rgba(0, 0, 0, 0.05)',
  '--success-color': '#28a745',
  '--important-color': '#ffc107',
  '--danger-color': '#dc3545',
};

export const WEEKDAYS = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];

export const FAMILY_MEMBERS = [
  { name: 'Oli', emoji: '👨', color: '#4285f4' },
  { name: 'Coco', emoji: '👩', color: '#ea4335' },
  { name: 'Pau', emoji: '👧', color: '#fbbc04' },
  { name: 'DD', emoji: '👩', color: '#34a853' },
  { name: 'Nico', emoji: '🧒', color: '#9c27b0' },
  { name: 'Alex', emoji: '👶', color: '#ff6d01' }
];